export const nullToUndefined = (v) => {
    const result = { ...v };
    Object.keys(v).forEach((k) => {
        if (v[k] === null) {
            delete result[k];
        }
    });
    return result;
};
//# sourceMappingURL=null-to-undefined.js.map